import Phaser from 'phaser';
import { Save } from '../save.js';
import { formatTime } from '../utils.js';

export class MenuScene extends Phaser.Scene {
  constructor() { super('Menu'); }

  create() {
    const W = this.scale.width, H = this.scale.height;
    const save = Save.load();

    this._stars = [];
    for (let i = 0; i < 80; i++) {
      const s = this.add.image(Math.random() * W, Math.random() * H, 'star_xs');
      s.setAlpha(0.3 + Math.random() * 0.7);
      s._speed = 12 + Math.random() * 40;
      this._stars.push(s);
    }

    const title = this.add.text(W / 2, 130, 'KNPPLZ', {
      fontFamily: 'Courier New, monospace',
      fontSize: '64px',
      color: '#b89cff',
      stroke: '#241540', strokeThickness: 6,
    }).setOrigin(0.5);
    this.tweens.add({
      targets: title, scale: { from: 1, to: 1.04 }, yoyo: true, repeat: -1, duration: 1400, ease: 'sine.inOut',
    });
    const ship = this.add.image(W / 2, 260, 'player').setScale(2.5);
    this.tweens.add({ targets: ship, y: 268, yoyo: true, repeat: -1, duration: 1200, ease: 'sine.inOut' });

    this._mkButton(W / 2, 360, 'START RUN', () => this.scene.start('Game'));
    this._mkButton(W / 2, 420, `UPGRADES  (${save.credits}c)`, () => this.scene.start('Shop'));

    const footer = `runs: ${save.runs}   best: ${formatTime(save.highTime)}   kills: ${save.totalKills}`;
    this.add.text(W / 2, H - 80, footer, {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#556677',
    }).setOrigin(0.5);

    this.add.text(W / 2, H - 40, 'WASD / Arrows to move    auto-fire   P / ESC = pause', {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#445566',
    }).setOrigin(0.5);

    this.input.keyboard.once('keydown-ENTER', () => this.scene.start('Game'));
    this.input.keyboard.once('keydown-SPACE', () => this.scene.start('Game'));

    this.input.keyboard.on('keydown-R', (ev) => {
      if (ev.shiftKey) {
        Save.reset();
        this.scene.restart();
      }
    });
  }

  update(time, delta) {
    const dt = delta / 1000;
    const H = this.scale.height;
    for (const s of this._stars) {
      s.y += s._speed * dt;
      if (s.y > H + 4) { s.y = -4; s.x = Math.random() * this.scale.width; }
    }
  }

  _mkButton(x, y, label, cb) {
    const t = this.add.text(x, y, label, {
      fontFamily: 'Courier New, monospace', fontSize: '22px',
      color: '#e8e8ff', backgroundColor: '#1a1430', padding: { x: 16, y: 8 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    t.on('pointerover', () => t.setStyle({ color: '#fff7ff', backgroundColor: '#3a256a' }));
    t.on('pointerout',  () => t.setStyle({ color: '#e8e8ff', backgroundColor: '#1a1430' }));
    t.on('pointerdown', cb);
    return t;
  }
}
